<template>
  <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">🔔 Phiên bản mới <b class="mx-1" style="color: #ffc107;">2.0.0</b> đã chính thức ra mắt!</v-card-title>

        <v-card-text>
         <p>Giao diện hoàn toàn mới - Thiết kế trực quan, tối ưu trải nghiệm người dùng với màu sắc tươi sáng và thao tác mượt mà hơn!</p>

         <p class="mb-0"><b>Tính năng mới nổi bật:</b></p>
        <ul style="padding-left: 18px; margin: 0 0 12px 0;">
          <li>Quản lý đa phương tiện - <i>Theo dõi cùng lúc nhiều xe, phân nhóm dễ dàng.</i></li>
          <li>Chia sẻ vị trí thời gian thực - <i>Cho phép người thân theo dõi hành trình.</i> </li>
          <li>Hỗ trợ tiếng Anh - <i>Mở rộng cho người dùng quốc tế.</i></li>
          <li>Báo cáo nâng cao - <i>Thống kê quãng đường, tiêu hao nhiên liệu, cảnh báo bảo dưỡng.</i></li>
        </ul>

        <p class="mb-0"><b>Cải tiến khác:</b></p>
        <ul style="padding-left: 18px; margin: 0 0 12px 0;">
          <li>Tối ưu hóa thời gian cập nhật vị trí.</li>
          <li>Sửa lỗi hiển thị bản đồ trên một số dòng điện thoại.</li>
        </ul>
        </v-card-text>

        <v-toolbar color="white">
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            flat="flat"
            @click="onCloseWelcomeDialog(false)"
          >
            Không nhắc lại
          </v-btn>

          <v-btn
            color="grey darken-1"
            flat="flat"
            @click="onCloseWelcomeDialog(true)"
          >
            Nhắc lại sau
          </v-btn>

          <button class="new-version-btn ml-3" @click="onMoveToNewVersion()" >
            <span class="label">Chuyển ngay</span>
            <span class="gradient-container">
              <span class="gradient"></span>
            </span>
          </button>
        </v-toolbar>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: {},

  data: () => ({
    dialog: false
  }),

  methods: {
    open () {
      this.dialog = true;
    },

    close () {
      this.dialog = false;
    },

    onCloseWelcomeDialog (repeat) {
      if (!repeat) {
        localStorage.setItem('NOT_SHOW_WELCOME_DIALOG', true);

      } else {
        sessionStorage.setItem('NOT_SHOW_WELCOME_DIALOG', true);
      }
      this.dialog = false;
    },

    onMoveToNewVersion () {
      this.$emit('move-to-new-version');
    }
  }
};
</script>

<style lang="stylus" scoped>
.new-version-btn {
  border: none;
  outline: none;
  background-color: #3a3a3a;
  font-size: 16px;
  color: #ffecb5;
  font-weight: 600;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
}

.new-version-btn::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  width: 106%;
  height: 125%;
  z-index: -1;
  border-radius: inherit;
  transition: all 0.3s;
}

.gradient-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 106%;
  height: 115%;
  overflow: hidden;
  border-radius: inherit;
  z-index: -2;
  filter: blur(10px);
  transition: all 0.3s;
}

.gradient {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 110%;
  aspect-ratio: 1;
  border-radius: 100%;
  transition: all 0.3s;
  background-image: linear-gradient(
    90deg,
    hsl(226, 81%, 64%),
    hsl(271, 81%, 64%),
    hsl(316, 81%, 64%),
    hsl(1, 81%, 64%),
    hsl(46, 81%, 64%),
    hsl(91, 81%, 64%),
    hsl(136, 81%, 64%),
    hsl(181, 81%, 64%)
  );
  animation: rotate 2s linear infinite;
  filter: blur(10px);
}

.label {
  text-align: center;
  border-radius: 8px;
  background-color: rgba(43, 43, 43, 1);
  background-image: linear-gradient(
    180deg,
    rgb(43, 43, 43) 0%,
    rgb(68, 68, 68) 100%
  );
  padding: 0.25rem 0.75rem;
}

.new-version-btn:hover .gradient-container {
  transform: translate(-50%, -50%) scale(0.98);
  filter: blur(5px);
}

.new-version-btn:hover .gradient {
  filter: blur(5px);
}

@keyframes rotate {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DialogNewVersion.vue